import { Component, OnInit } from '@angular/core';
import { RelatorioService } from './relatorio.service';
import {environment} from "../../environments/environment";

import { Utils } from './../shared/utils';
import { PER_PAGE } from './../constante';
import { TipoCertificadoService } from 'app/tipos_certificados/tipo_certificado.service';
import { GrupoService } from 'app/grupos/grupo.service';

@Component({
  selector: 'app-relatorios',
  templateUrl: './relatorios.component.html',
  styleUrls: ['./relatorios.component.css'],
  providers: [RelatorioService, GrupoService]
})
export class RelatoriosComponent implements OnInit {
  titulo:string = 'Relatório';
  relatorios:any[];
  public params:any = {from:undefined, to:undefined};
  public busy: Promise<any>;
  public paginaAtual: number = 1;
  public itensPorPagina: number = PER_PAGE;
  public groups: any[] = [];

  public dataOptions = [{
    format: 'dd/mm/yyyy',
    monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mar', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    monthsFull: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    weekdaysFull: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'],
    weekdaysShort: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
    today: 'Hoje',
    clear: 'Limpar',
    close: 'OK',
    closeOnSelect: true
  }];

  public dataOptionsTo = [{
    format: 'dd/mm/yyyy',
    monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mar', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    monthsFull: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    weekdaysFull: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'],
    weekdaysShort: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
    today: 'Hoje',
    clear: 'Limpar',
    close: 'OK',
    closeOnSelect: true,
    yearRange: 1, 
    min: this.params.from,
    max: this.maxData
  }];

  constructor( private relatorioService: RelatorioService, private grupoService: GrupoService) { }

  get minData(){
    let date  = new Date(this.params.to);
    date.setFullYear(date.getFullYear() - 1)
    console.log('date: ', date);

    let day: any = date.getDate();
    let month: any = date.getMonth();

    if (day < 10) {
      day = '0' + day;
    }

    if (month < 10) {
      month = `0${month}`;
    }

    return date.getFullYear() + "-" + month + "-" + day;
  }

  get maxData(){
    let date  = new Date(this.params.from);
    date.setFullYear(date.getFullYear() + 1)
    console.log('date: ', date);

    let day: any = date.getDate();
    let month: any = date.getMonth();

    if (day < 10) {
      day = '0' + day;
    }

    if (month < 10) {
      month = `0${month}`;
    }

    return date.getFullYear() + "-" + month + "-" + day;
  }

  somethingChanged(){
    console.log('testando');
  }
  pesquisar(): void {
    if(this.params.from !== undefined && this.params.to !== undefined){
      this.busy = this.relatorioService.pesquisar(this.params)
        .then(documentos => this.relatorios = documentos);
    }
  }

  baixar(): void {
    if(this.params.from !== undefined && this.params.to !== undefined){
      let url:string = environment.url_api + "/imprimir?from="+ this.params.from+"&to="+this.params.to + "&groupIds=" + this.params.groupIds.join(',');
      window.open(url, '_blank');
    }
  }  

  getGrupos(): void {
    this.busy = this.grupoService.getAllGrupos()
      .then(grupos =>{ 
        this.groups = grupos;
        this.params.groupIds = this.groups.map(i => i['id']);      
      });
  }

  ngOnInit() {
    this.getGrupos();
  }

}



// WEBPACK FOOTER //
// ./src/app/relatorios/relatorios.component.ts